import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isSuperAdmin: true,
  info: {},
  rolesPermissions: {},
}

const rolePermissionSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setroleinfo: (state, { payload }) => {
      state.info = { ...payload }
    },
    setrolesPermissions: (state, { payload }) => {
      state.rolesPermissions = { ...payload }
    },
    setisSuperAdmin: (state, { payload }) => {
      state.isSuperAdmin = payload
    },
  },
})

export const { setroleinfo, setisSuperAdmin, setrolesPermissions } =
  rolePermissionSlice.actions

export default rolePermissionSlice.reducer
